/* @flow */
import React from 'react';
import classnames from 'classnames';
// Styles
import styles from './styles.scss';

type InternalSellerNameProps = {|
    sellerName: string,
    isTestVariant?: boolean,
|};

export function InternalSellerName({ sellerName, isTestVariant }: InternalSellerNameProps) {
    return (
        <div
            className={classnames(styles.internalByline, { [styles.isTestVariant]: isTestVariant })}
            data-tn="internal-seller-name"
        >
            {sellerName}
        </div>
    );
}

export default InternalSellerName;
